/**
 * 医生直播入口卡片
 * author: zhangjie13
 */

import React, { useState, useEffect } from 'react';
import { ILive } from '@schemas/video';
import { useInView } from 'react-intersection-observer';
import { sendShow, sendClick, formatNumber, className } from '@utils/helpers';
import LoadImage from '@assets/load-image.png';
import AvatarImage from '@assets/me.png';
import { openOrDownloadUrl } from '@utils/open-or-download-url';
import WebImage from '@/components/WebImage';
import IconFont from '@/components/Iconfont';
import styles from './index.module.scss';

interface ILiveCardProps {
  liveIndex: number;
  live: ILive;
}

const LiveCard = ({ liveIndex, live }: ILiveCardProps) => {
  const [imgPos, setImgPos] = useState(0);
  const [imgError, setImgError] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      sendShow('KWAI_HEALTHY_LIVE_LIST', {
        index: `${liveIndex  }`,
        live_stream_id: `${live.liveStreamId  }`,
        anchor_id: `${live.userId  }`
      });
    }
  }, [inView]);

  const handleLiveClick = () => {
    sendClick('KWAI_HEALTHY_LIVE_LIST', {
      index: `${liveIndex  }`,
      live_stream_id: `${live.liveStreamId  }`,
      anchor_id: `${live.userId  }`
    });
    const url = live.liveStatus === 200 ? live.link : live.replayLink;
    if (url) {
      openOrDownloadUrl(url);
    }
  };

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight, width, height } = e.target;
    const imageRatio = naturalWidth / naturalHeight;
    const uiRatio = width / height;
    if (imageRatio < uiRatio) {
      setImgPos((naturalHeight / (naturalWidth / width) - height) / 4);
    }
  };

  const handleImgError = () => {
    setImgError(true);
  };

  return (
    <li
      aria-hidden
      ref={ref}
      className={styles['live-card']}
      onClick={handleLiveClick}
    >
      <div className={styles['img-wrapper']}>
        {/* 图片上的灰色层 */}
        <div className={styles['gray-layer']}>
          {live.liveStatus === 200 ? (
            <div className={className(styles['live-status'], styles.online)}>
              直播中
            </div>
          ) : (
            <div
              className={className(styles['live-status'], styles.playback)}
            >
              回放
            </div>
          )}
          {live.liveStatus === 200 ? (
            <div className={className(styles['watching-count'])}>
              <IconFont icon="common_base_personal_24" />
              <span>{formatNumber(live.watchingCount)}</span>
            </div>
          ) : null}
        </div>

        {inView && !imgError ? (
          <img
            onLoad={handleImageLoad}
            src={live.coverThumbnailUrl}
            alt=""
            style={{
              objectPosition: imgPos !== 0 ? `50% -${imgPos}px` : '50% 50%'
            }}
            onError={handleImgError}
          />
        ) : (
          <img src={LoadImage} alt="" />
        )}

        {/* <div className="info-wrapper">
          <div>
            <h2>{live.doctorName}</h2>
            <h3>
              {live.department}
              {live.doctorRankName}
            </h3>
          </div>
          <div>
            <h4>{live.hospitalLevel}</h4>
            <h4>{live.affiliationHospital}</h4>
          </div>
        </div> */}
      </div>
      <h1>{live.caption ? live.caption : '健康直播正在进行中'}</h1>
      <div className={styles['doctor-info']}>
        <WebImage url={live.headUrl} defaultImg={AvatarImage} />
        {/* {live.followed && <div className="followed-card">已关注</div>} */}
        {/* <h3 className={live.followed ? 'followed-rank' : ''}> */}
        <h3>
          {live.doctorName} {live.doctorRankName}
        </h3>
      </div>
    </li>
  );
};

export default LiveCard;
